export default {
  English: 'English',
  Français: 'French',
  Deutsch: 'German',
  Italliano: 'Italian',
  Español: 'Spanish',
  Next: 'Next',
  Back: 'Back',
  // META DATA in general file
  // TOP LINE PAY LATER in general file
  // PAY LATER MODAL INFO WINDOW  in general file
  // STEP 1 TILES in general file
  // STEP2  in general file

  // STEP3 -- partially in general file (title and All you can eat bundle)

  TILE_BUNDLE_MAIN_TITLE: '<b>vCard Wizard + 4 Bundle</b>',
  TILE_BUNDLE_MAIN_TITLE_DIV: 'vCard Wizard + 4 Bundle',
  TILE_BUNDLE_MAIN_DESCRIPTION1: 'Add backup, deduplication and repairing tools',
  TILE_BUNDLE_MAIN_TITLE_MODAL: '<b>vCard Wizard + 4 Bundle</b>',
  TILE_BUNDLE_MAIN_DESCRIPTION_MODAL: 'Buy vCard Wizard + 4 Bundle and you will receive:',
  TILE_BUNDLE_MAIN_SL_DESCRIPTION: ' - set a schedule for sending your e-mail messages.',
  TILE_BUNDLE_MAIN_DR_DESCRIPTION: ' - find and remove Outlook duplicate items in just one click.',
  TILE_BUNDLE_MAIN_SPB_DESCRIPTION: ' - automatic Outlook PST and Exchange folders backup tool.',
  TILE_BUNDLE_MAIN_OT_DESCRIPTION: ' - resolve Outlook problems with Outlook toolbox.',

  TILE_BUNDLE_MAIN_VC_DESCRIPTION: ' - easily Transfer Contacts between Multiple files and Cloud sources.',

  TILE_BUNDLE_MAIN_SL_NAME: 'SendLater',
  TILE_BUNDLE_MAIN_SL_URL: 'https://www.sendlateremail.com/',

  TILE_BUNDLE_MAIN_DR_NAME: 'Outlook Duplicate Remover',
  TILE_BUNDLE_MAIN_DR_URL: 'https://www.duplicate-remover.com/',

  TILE_BUNDLE_MAIN_VC_NAME: 'vCard Wizard',
  TILE_BUNDLE_MAIN_VC_URL: 'https://www.vcardwizard.com/',

  TILE_BUNDLE_MAIN_SPB_NAME: 'Safe PST Backup',
  TILE_BUNDLE_MAIN_SPB_URL: 'https://www.safepstbackup.com/',
  TILE_BUNDLE_MAIN_OT_NAME: 'Outlook Toolbox',
  TILE_BUNDLE_MAIN_OT_URL: 'https://outlooksupport.4team.biz/resolve-outlook-problems-with-outlook-toolbox',

  // STEP4  in general file

  // Tiles buttons  in general file
  // Tiles links  in general file
  // Tiles Price & Save  in general file

  // MODAL WHY UPGRADE in general file
  // MODAL WHY LIFETIME UPGRADE in general file
  // MODAL WHY SUBSCRIPTION UPGRADE in general file

  // MODAL BUNDLES ADDITIONAL TEXT   in general file
  // MODAL LIFETIME ADDITIONAL TEXT   in general file

  // PURCHASE STEPS BAR --   in general file
  // NOTES AND PAYMENT CARDS ICONS in general file

  // INFO LINKS--   in general file
  // FOOTER--   in general file
  // EMAIL VALIDATION--   in general file

  // burger menu
  MENU_DOWNLOAD: 'Download',
  MENU_DOWNLOAD_TITLE: 'Click here to download vCard Wizard',
  MENU_FEATURES: 'Features',
  MENU_FEATURES_TITLE: 'Take a Tour',
  MENU_PRICING: 'Pricing',
  MENU_PRICING_TITLE: 'Pricing',
  MENU_TESTIMONIALS: 'Testimonials',
  MENU_TESTIMONIALS_TITLE: 'Click here to view vCard Wizard reviews, customer testimonials and feedbacks',
  MENU_FAQ: 'FAQ',
  MENU_FAQ_TITLE: 'Click here to read frequently asked questions',
  MENU_SUPPORT: 'Support',
  MENU_SUPPORT_TITLE: 'Support',
  MENU_RESOURCES: 'Resources',
  MENU_RESOURCES_TITLE: 'Resources',
  MENU_RESOURCES_SCREENSHOTS_VIDEO: 'Screenshots & Videos',
  MENU_RESOURCES_SCREENSHOTS_VIDEO_TITLE: 'Screenshots & Videos',
  MENU_RESOURCES_DOCUMENTATION: 'Documentation',
  MENU_RESOURCES_DOCUMENTATION_TITLE: 'Documentation',
  MENU_RESOURCES_INSTALLATION_INSTRUCTIONS: 'Installation Instructions',
  MENU_RESOURCES_INSTALLATION_INSTRUCTIONS_TITLE: 'Installation Instructions',
  MENU_RESOURCES_VERSION_HISTORY: 'Version history',
  MENU_RESOURCES_VERSION_HISTORY_TITLE: 'Version history',
  MENU_RESOURCES_SYSTEM_REQUIREMENTS: 'System requirements',
  MENU_RESOURCES_SYSTEM_REQUIREMENTS_TITLE: 'System requirements',
  MENU_RESOURCES_FAQ: 'Frequently Asked Questions',
  MENU_RESOURCES_FAQ_TITLE: 'Frequently Asked Questions',
  MENU_RESOURCES_HELP: 'Help',
  MENU_RESOURCES_HELP_TITLE: 'Help',
  MENU_MY_ACCOUNT: 'My Account',
  MENU_MY_ACCOUNT_TITLE: 'Review your account details',
  MENU_SELECT_LANG: 'Select Your Language',
  MENU_SELECT_LANG_TITLE: 'Select Your Language',
  MENU_CLOSE: 'Close',

  // PAGE LINKS:
  URL_ABOUT_US: 'https://www.4team.biz/about.aspx',
  URL_LICENSING: 'https://www.vcardwizard.com/licensing',
  URL_FAQ: 'https://www.vcardwizard.com/frequently-asked-questions.aspx',
  URL_SYSTEM_REQUIREMENTS: 'https://www.vcardwizard.com/system-requirements',
  URL_SUPPORT: 'https://www.4team.biz/livehelp.aspx',
  URL_REFUND_POLICY: 'https://www.vcardwizard.com/refundpolicy',

  // structured data
  SD_PR_NAME: 'vCard Wizard',
  SD_PR_DESCRIPTION: 'Purchase, buy #PR_NAME# license and activation code. Order Outlook Tech Support and #PR_NAME# bundle.',
  SD_PR_IMAGE: 'https://www.vcardwizard.com/i/logo.png',
  SD_PR_OPERATING_SYSTEM: 'Windows',
  SD_PR_VERSION: '4.30.0256',
  SD_PR_CATEGORY: 'Productivity',
  SD_PR_DOWNLOAD_URL: 'https://www.vcardwizard.com/download.aspx',
  SD_PR_RELEASE_NOTES: 'https://www.vcardwizard.com/version-history.aspx',
  SD_PR_AUTHOR_NAME: '4Team Corporation',
  SD_PR_URL: 'https://www.vcardwizard.com/',

  SD_OFFERS_PRICE_CURRENCY_USD: 'USD',
  SD_OFFERS_PRICE_USD: '39.95',
  SD_OFFERS_URL_USD: 'https://www.vcardwizard.com/purchase/licenses',

  SD_OFFERS_PRICE_CURRENCY_GBP: 'GBP',
  SD_OFFERS_PRICE_GBP: '29.95',
  SD_OFFERS_URL_GBP: 'https://www.vcardwizard.com/purchase/licenses',

  SD_OFFERS_PRICE_CURRENCY_EUR: 'EUR',
  SD_OFFERS_PRICE_EUR: '39.95',
  SD_OFFERS_URL_EUR: 'https://www.vcardwizard.com/purchase/licenses',

  SD_RATING_WORST: '1',
  SD_RATING_BEST: '5',
  SD_RATING_VALUE: '4.9',
  SD_RATING_COUNT: '511',

  SD_ORGANIZATION_NAME: '4Team Corporation',
  SD_ORGANIZATION_IMAGE: 'https://www.4team.biz/i/4Team_logo_2.png',
  SD_ORGANIZATION_URL: 'https://www.4team.biz',
  SD_ORGANIZATION_ADDRESS: '5645 Coral Ridge Dr #211',
  SD_ORGANIZATION_CITY: 'Coral Springs',
  SD_ORGANIZATION_REGION: 'FL',
  SD_ORGANIZATION_ZIP: '33076',
  SD_ORGANIZATION_COUNTRY: 'USA',
  SD_ORGANIZATION_PHONE_USA: ' +1 (954) 796-8161',

  // end structured data
  STEP8_PAGE_PRODUCT_DOWNLOAD_LINK: '<a href="https://d.4team.biz/files/vcard_setup.exe">vCard Wizard</a>',

  // PRO Texts
  TILE_LICENSE_TITLE_PRO: '<b>User License</b>',
  TILE_LICENSE_TITLE_DIV_PRO: 'User License',
  TILE_LICENSE_MODAL_TITLE_PRO: '<b>#PR_NAME# PRO PLUS User License</b>',

  TILE_SINGLE_LIC_UPGRADE_TITLE_PRO: '<b>User License Renewal</b>',
  TILE_SINGLE_LIC_UPGRADE_TITLE_DIV_PRO: 'User License Renewal',
  TILE_SINGLE_LIC_UPGRADE_MODAL_TITLE_PRO: '<b>#PR_NAME# PRO PLUS User License Renewal</b>',

  TILE_LIC_UPGRADE_TITLE_PRO: '<b>License Renewal<br>for Additional Year</b>',
  TILE_LIC_UPGRADE_TITLE_DIV_PRO: 'License Renewal for Additional Year',
  TILE_LIC_UPGRADE_MODAL_TITLE_PRO: 'License Renewal for Additional Year',

  TILE_LIFETIME_UPGRADE_TITLE_PRO: '<b>Lifetime License</b>',
  TILE_LIFETIME_UPGRADE_TITLE_DIV_PRO: 'Lifetime License',
  TILE_LIFETIME_UPGRADE_MODAL_TITLE_PRO: 'Lifetime License',

  // SUBSCRIPTION TILES
  TILE_SUBSCRIPTION_TITLE3_PRO: '<b>User License Subscription</b>',
  TILE_SUBSCRIPTION_TITLE_DIV_PRO: 'User License Subscription',
  TILE_SUBSCRIPTION_MODAL_TITLE_PRO: '#PR_NAME# PRO PLUS User License Subscription',

  // SUBSCRIPTION LT TILES
  TILE_SUBSCRIPTION_LT_TITLE3_PRO: '<b>Lifetime Subscription</b>',
  TILE_SUBSCRIPTION_LT_TITLE_DIV_PRO: 'Lifetime Subscription',
  TILE_SUBSCRIPTION_LT_MODAL_TITLE_PRO: '#PR_NAME# PRO PLUS Lifetime Subscription',
}
